import React from "react";
import { profile } from "../mock/mock";
import { Quote } from "lucide-react";

const About = () => {
  return (
    <section id="summary" className="py-24 lg:py-32 bg-ivory-100/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-bronze" />
              <span className="text-[11px] uppercase tracking-[0.3em] text-ink/60">
                Executive Summary
              </span>
            </div>
            <h2 className="font-serif-display text-4xl lg:text-5xl text-ink leading-[1.05] font-light">
              A senior executive with the range to lead across operations, technology and commerce.
            </h2>

            <div className="mt-10 space-y-3 text-sm">
              <div className="flex justify-between border-b border-ink/10 pb-2">
                <span className="text-ink/55 uppercase tracking-wider text-xs">Based in</span>
                <span className="text-ink">{profile.location}</span>
              </div>
              <div className="flex justify-between border-b border-ink/10 pb-2">
                <span className="text-ink/55 uppercase tracking-wider text-xs">Experience</span>
                <span className="text-ink">15+ years</span>
              </div>
              <div className="flex justify-between border-b border-ink/10 pb-2">
                <span className="text-ink/55 uppercase tracking-wider text-xs">Markets</span>
                <span className="text-ink">UAE · KSA · Oman</span>
              </div>
              <div className="flex justify-between border-b border-ink/10 pb-2">
                <span className="text-ink/55 uppercase tracking-wider text-xs">Languages</span>
                <span className="text-ink">
                  {profile.languages.map((l) => l.name).join(" · ")}
                </span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="space-y-6">
              {profile.about.map((para, i) => (
                <p key={i} className="text-[17px] text-ink/85 leading-[1.75]">
                  {para}
                </p>
              ))}
            </div>

            {/* Pull quote */}
            <div className="relative mt-12 pl-6 border-l-2 border-bronze">
              <Quote className="absolute -top-1 -left-3 h-6 w-6 text-bronze bg-ivory-100 rounded-full p-0.5" />
              <p className="font-serif-display text-2xl lg:text-3xl text-ink italic leading-snug">
                &ldquo;{profile.pullQuote}&rdquo;
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
